import Image from "next/image";
import Link from "next/link";
import { useUserContext } from "../../context/UserContext";
import defaultUserInfo from "../../data/default/UserInfo";

import avatar from "../../public/images/team/avatar-black.svg";
import UserMenuItems from "./HeaderProps/UserMenuItems";
import { useRouter } from "next/router";
import auth from '@/context/firebaseconfig';
import { browserLocalPersistence, inMemoryPersistence } from 'firebase/auth';

import dynamic from 'next/dynamic';
const UserName = dynamic(() => import('./UserName'), { ssr: false });

const UserMenu = () => {
  const router = useRouter()
  const { userInfo, setUserInfo, userLoggedIn, setUserLoggedIn } = useUserContext();

  const handleLogout = async () => {
    try {
      // Sign out from Firebase
      await auth.signOut();


      console.log("Logout successful");

      // Redirect to sign in page
      router.push('/SignIn');
    } catch (error) {
      console.error("Error during logout:", error);
      // You might want to show an error message to the user here
    }
  };
  return (
    <>
      <div className="inner">
        <div className="rbt-admin-profile">
          <div className="admin-thumbnail">
            <Image src={avatar} alt="User Images" />
          </div>
          <div className="admin-info">
            <UserName />
            {userLoggedIn && (
            <Link
              className="rbt-btn-link color-primary"
              href="/profile-details"
            >
              View Profile
            </Link>
            )}
          </div>
        </div>
        <UserMenuItems parentClass="user-list-wrapper user-nav" />
        {/* <hr className="mt--10 mb--10" /> */}
        {/* <ul className="user-list-wrapper user-nav">
          <li>
            <Link href="#">
              <i className="feather-help-circle"></i>
              <span>Help Center</span>
            </Link>
          </li>
          <li>
            <Link href="/profile-details">
              <i className="feather-settings"></i>
              <span>Settings</span>
            </Link>
          </li>
        </ul> */}
        <hr className="mt--10 mb--10" />
        <ul className="user-list-wrapper">
          {userLoggedIn ? (
          <li>
            <Link href="/SignIn">
              {/* <button style={{border:'none',background:'transparent'}}> */}
              <i className="feather-log-out"></i>
              <span onClick={handleLogout}>Logout</span>
              {/* </button> */}
            </Link>
          </li>
          ) : (
            <li>
              <Link href="/SignUp">
                <i className="feather-log-out"></i>
                <span>Sign Up</span>
              </Link>
            </li>
          )}  
        </ul>
      </div>
    </>
  );
};

export default UserMenu;
